<template>
    <div class="wrapper" v-bar>
        <div ref="scroll">
            <div v-for="post in data">
                <LinkPost v-if="post.kind==='t3'" :post="post"/>
                <MultiCommentPost v-if="post.kind==='t1'" :posts="post.comments"/>
            </div>
        </div>
    </div>
</template>

<script>
    import LinkPost from "./LinkPost";
    import MultiCommentPost from "./MultiCommentPost";

    export default {
        props: {
            posts: Array
        },
        components: {LinkPost, MultiCommentPost},
        updated() {
            this.$refs.scroll.scrollTo(0, 0)
        },
        computed: {
            data() {

                let links = this.posts.filter(d => d.kind === 't3').map(d => {
                    d.data.kind = d.kind;
                    return d.data;
                });

                let comments = this.posts.filter(d => d.kind === 't1').map(d => d.data).sort((a, b) => b.created_utc - a.created_utc).reduce((a, c) => {
                    if (a[c.link_id]) {
                        // and then fill the comments
                        a[c.link_id].comments.push(c)
                    } else {
                        // create the object
                        a[c.link_id] = {
                            kind: 't1',
                            comments: [c],
                            link_id: c.link_id,
                            created_utc: c.created_utc
                        }
                    }
                    return a;
                }, {});

                return links.concat(Object.values(comments)).sort((a, b) => b.created_utc - a.created_utc);
            }
        }
    }
</script>

<style scoped>
    .wrapper {
        height: 85%;
    }
</style>
